import styles from './index.module.scss'
import { Row, Table, Select, DatePicker, message, Input } from 'antd'
import { useState, useEffect, useContext, useMemo } from 'react'
import PSAIModal from '@PSAIComponents/PSAIModal';
import TabCom from '../../hooks/TabCom'
import styles2 from '../index.module.scss'
import API from '@api/api';
import { AppContext } from '@utils/AppContext';
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons'
import eventBus from '@utils/eventBus';
const { RangePicker } = DatePicker;



const TeamTable = () => {
    const { globalOrgInfo, globalBalance, globalUser } = useContext(AppContext);
    const [logLoading, setLogLoading] = useState(false);
    const [logLoading2, setLogLoading2] = useState(false);
    const [activeIndex, setActiveIndex] = useState('useDetail');
    const [memberList, setMemberList] = useState([]);
    const [member, setMember] = useState();
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [open, setOpen] = useState(false);
    const [oneList, setOneList] = useState([]);
    const [secondList, setSecondList] = useState([]);
    const [distributeList, setDistributeList] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [beanBalance, setbeanBalance] = useState(0);
    const [oneListColumns, setOneListColumns] = useState([
        {
            title: '成员昵称',
            key: 'nickName',
            width: 200,
            align: 'center',
            render: (record) => {
                return record.deleted ? <span style={{ color: '#B9C3D0' }}>{record.nickName}（已移除）</span> : record.nickName
            }
        },
        {
            title: '消耗虹豆',
            dataIndex: 'total',
            sorter: (a, b) => a.total - b.total,
            key: 'total',
            align: 'center',
            width: 120,
        },
    ]);
    const [secondListColumns, setSecondListColumns] = useState([
        {
            title: '消耗类型',
            key: 'category',
            align: 'center',
            dataIndex: 'category',
            width: 200,
        },
        {
            title: '消耗虹豆',
            dataIndex: 'total',
            sorter: (a, b) => a.total - b.total,
            key: 'total',
            align: 'center',
            width: 120,
        },
    ])
    const distributeColumns = [
        {
            title: '成员昵称',
            key: 'orgNickname',
            dataIndex: 'orgNickname',
            width: 200,
        }, {
            title: '可用虹豆',
            key: 'powerBalance',
            dataIndex: 'powerBalance',
        }, {
            title: '已分配虹豆总数',
            key: 'powerAmount',
            render: (text, record, index) => (
                index === 0 ? '-' : record.powerAmount
            ),
        }, {
            title: '操作',
            width: 200,
            render: (text, record, index) => (
                index === 0 || memberLevel == 0 ? '-' :
                    <span
                        style={{ cursor: 'pointer', color: '#006EFF' }}
                        onClick={() => {
                            setOpen(true)
                            setbeanBalance(distributeList?.[0]?.powerBalance)
                            setBindingId(record.bindingId)
                            setOrgNickname(record.orgNickname)
                        }}>
                        分配虹豆
                    </span>
            ),
        },
    ];

    const [titleList, setTitleList] = useState()

    useEffect(() => {
        setTitleList(globalOrgInfo?.current?.powerAllocateMode ? [
            { label: '使用明细', key: 'useDetail' },
            { label: '额度分配', key: 'allocation' },
        ] : [
            { label: '使用明细', key: 'useDetail' },
        ])
        if (!globalOrgInfo?.current?.powerAllocateMode) {
            setActiveIndex('useDetail')
        }
        getListOrgMember();
        getListUserOrgVip();
    }, [globalOrgInfo?.current?.powerAllocateMode])

    const memberChange = value => {
        setMember(value);
    };

    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) return message.error(res.msg);
            const list = res.data.map(item => ({
                value: item.userId,
                label: item.deleted ? item.orgNickname + '（已移除）' : item.orgNickname,
            }));
            setMemberList(list);
        });
    };

    // 额度分配列表
    const getListUserOrgVip = () => {
        API.listUserOrgVip({}).then((res) => {
            if (res.code !== 0) return message.error(res.msg);
            console.log('res.data', res.data)
            setDistributeList([...res.data]);
        });
    };

    // 一级table
    const listOrgPowerUsageStat = () => {
        setLogLoading(true);
        API.listOrgPowerUsageStat({
            member,
            start,
            end,
        }).then((res) => {
            setLogLoading(false);
            if (res.code !== 0) return message.error(res.msg);

            generateColumnsFromDates(res.attr?.dateRange, setOneListColumns);

            const transformedData = res.data?.map(item => {
                const { dailyStat, ...rest } = item;
                return { ...rest, ...dailyStat };
            }) || [];

            setOneList(transformedData);
        });
    };

    // 展开二级table
    const listOrgPowerUsageStatDetail = (userId) => {
        setLogLoading2(true);
        API.listOrgPowerUsageStatDetail({
            member: userId,
            start,
            end,
        }).then((res) => {
            setLogLoading2(false);
            if (res.code !== 0) return message.error(res.msg);

            generateColumnsFromDates(res.attr?.dateRange, setSecondListColumns);

            const transformedData = res.data?.map(item => {
                const { dailyStat, ...rest } = item;
                return { ...rest, ...dailyStat };
            }) || [];

            setSecondList(transformedData);
        });
    };

    // 处理表头
    const generateColumnsFromDates = (dateArray, cb) => {
        const dynamicColumns = dateArray?.map(date => ({
            title: date,
            dataIndex: date,
            key: date,
            width: 120,
            align: 'center',
        })) || [];

        cb(prevColumns => {
            const baseColumns = prevColumns.slice(0, 2);
            return [...baseColumns, ...dynamicColumns, {
                title: null,
                dataIndex: null,
                key: 'null',
                width: 1200,
                align: 'center',
            }];
        });
    };

    const handleRowExpand = (expanded, record) => {
        if (expanded) {
            listOrgPowerUsageStatDetail(record.userId);
            setExpandedRowKeys([record.userId]);
        } else {
            setExpandedRowKeys([]);
        }
    };

    useEffect(() => {
        setExpandedRowKeys([])
        listOrgPowerUsageStat();
    }, [member, start, end]);

    //分配虹豆
    const [beanCount, setBeanCount] = useState(0)
    const [bindingId, setBindingId] = useState()
    const [orgNickname, setOrgNickname] = useState()
    const increaseBeanCount = () => {
        setBeanCount(prevCount => prevCount + 1000)
    }

    const decreaseBeanCount = () => {
        setBeanCount(prevCount => Math.max(0, prevCount - 1000))
    }

    // 分配虹豆
    const postAllocatePower = () => {
        console.log('asdasd')
        API.postAllocatePower({
            bindingId,
            amount: beanCount,
        }).then((res) => {
            if (res.code == 0) {
                message.success('分配成功');
                setOpen(false);
                setBeanCount(0);
                setBindingId('');
                setOrgNickname('');
                getListUserOrgVip();
                eventBus.emit('updateUserInfo')
                eventBus.emit('getUserOrgInfo')
                eventBus.emit('updatePower')
                eventBus.emit('updateActivityInfo')
            } else if (res.code == -5064) {
                setBeanCount(0);
                setReminderVisible(true)
            } else {
                message.error(res.msg)
            }

        });
    }

    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100) ?
            globalUser?.membership?.level : 0
    }, [globalUser])
    const [reminderVisible, setReminderVisible] = useState(false)
    const reminderOK = () => {
        if (memberLevel !== 0) {
            eventBus.emit('OPEN_DATA_PACKAGE')
        } else {
            eventBus.emit('recharge')
        }
    }

    return (
        <div className={styles.TeamTable}>
            <TabCom items={titleList} getActiveIndex={setActiveIndex} />
            {
                activeIndex === 'useDetail' && <Row className={styles.titleRow}>
                    <span>成员</span>
                    <Select
                        style={{ width: 210 }}
                        showSearch
                        optionFilterProp="label"
                        value={member}
                        allowClear
                        onChange={memberChange}
                        placeholder="请选择成员"
                        options={memberList}
                    />
                    <span style={{ marginLeft: '60px' }}>日期</span>
                    <RangePicker
                        style={{ width: 250 }}
                        format="YYYY-MM-DD"
                        disabledDate={(current) => {
                            // 限制只能选择过去90天内的日期
                            const today = new Date();
                            const ninetyDaysAgo = new Date();
                            ninetyDaysAgo.setDate(today.getDate() - 90);

                            return current && (
                                current > today ||
                                current < ninetyDaysAgo
                            );
                        }}
                        onChange={(value) => {
                            if (value) {
                                setStart(value[0].format('YYYY-MM-DD'));
                                setEnd(value[1].format('YYYY-MM-DD'));
                            } else {
                                setStart(null);
                                setEnd(null);
                            }
                        }}
                    />
                </Row>
            }

            {activeIndex === 'useDetail' ? (
                <Table
                    className="personalTable"
                    loading={logLoading}
                    rowKey={(record) => record.userId}
                    pagination={false}
                    expandable={{
                        expandedRowRender: (record) => (
                            <Table
                                showHeader={false}
                                className="personalTable"
                                loading={logLoading2}
                                rowKey={(record) => `child-${record.userId}`}
                                pagination={false}
                                columns={secondListColumns}
                                dataSource={secondList}
                                tableLayout="auto"

                            />
                        ),
                        expandedRowKeys,
                        onExpand: handleRowExpand,
                        rowExpandable: () => true,
                    }}
                    columns={oneListColumns}
                    dataSource={oneList}
                    tableLayout="auto"
                    scroll={{
                        x: 'max-content',
                        y: `calc(100vh - 600px)`,
                    }}
                />
            ) : (
                <Table
                    className="personalTable"
                    loading={logLoading}
                    rowKey={(record) => record.bindingId}
                    pagination={false}
                    columns={distributeColumns}
                    dataSource={distributeList}
                    tableLayout="auto"
                    scroll={{
                        x: 'max-content',
                        y: `calc(100vh - 600px)`,
                    }}
                />
            )}

            <PSAIModal
                title={`为${orgNickname}分配虹豆`}
                maxWidth={400}
                okText="确定"
                open={open}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false }}
                onCancel={() => setOpen(false)}
                onOk={() => postAllocatePower()}
            >
                <div className={styles.modelContent}>
                    <MinusCircleFilled
                        className={styles.minusIcon}
                        style={{ color: beanCount === 0 ? '#E3E9F0' : '#52A8FF' }}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => { e.stopPropagation(); decreaseBeanCount() }} />
                    <Input style={{ width: 200 }} onChange={(e) => setBeanCount(e.target.value)} value={beanCount} />
                    <PlusCircleFilled
                        className={styles.plusIcon}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => { e.stopPropagation(); increaseBeanCount() }} />
                    <p>剩余 {beanBalance} 虹豆</p>
                </div>
            </PSAIModal>
            <PSAIModal
                title={null}
                maxWidth={320}
                okText={'购买虹豆'}
                open={reminderVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false, style: { width: '80%', margin: '0' } }}
                onCancel={() => setReminderVisible(false)}
                onOk={() => reminderOK()}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div className={styles.modelContent}>
                    您目前分配的虹豆数量已超过购买的数量，请购买更多虹豆进行分配
                </div>
            </PSAIModal>
        </div>
    );
};

export default TeamTable;
